const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.2234 30.5565C12.2234 30.5809 12.2008 30.6176 12.1556 30.6665H11.8056C11.7905 30.6502 11.6851 30.5402 11.4894 30.3364C11.2937 30.1326 11.1243 29.9573 10.9813 29.8106C10.8382 29.6639 10.635 29.4152 10.3715 29.0647C10.108 28.7142 9.87466 28.3841 9.67141 28.0743C9.46816 27.7646 9.23103 27.3529 8.96003 26.8394C8.68903 26.3258 8.45566 25.8163 8.25994 25.3109C8.06422 24.8055 7.8572 24.1983 7.63889 23.4891C7.42058 22.7799 7.25121 22.0625 7.13076 21.3371C7.01032 20.6116 6.90116 19.7842 6.8033 18.8549C6.70544 17.9256 6.66027 16.9719 6.6678 15.9937C6.6678 10.198 8.03787 5.67387 10.778 2.4214C10.9511 2.21761 11.113 2.03828 11.2636 1.8834C11.4141 1.72852 11.5383 1.59809 11.6362 1.49212C11.734 1.38615 11.7905 1.33317 11.8056 1.33317H12.1556C12.2008 1.38208 12.2234 1.41876 12.2234 1.44322C12.2234 1.48397 12.1481 1.58994 11.9975 1.76113C11.847 1.93231 11.6512 2.17278 11.4103 2.48254C11.1695 2.7923 10.8985 3.17949 10.5973 3.64413C10.2962 4.10877 9.99135 4.69161 9.6827 5.39264C9.37406 6.09367 9.088 6.87214 8.82453 7.72806C8.56105 8.58397 8.33522 9.61106 8.14702 10.8093C7.95883 12.0076 7.83838 13.2956 7.78568 14.6732C7.77063 14.9829 7.7631 15.4272 7.7631 16.0059C7.7631 19.1769 8.11691 21.9484 8.82453 24.3205C9.53215 26.6926 10.6237 28.7061 12.0991 30.3608C12.182 30.4586 12.2234 30.5239 12.2234 30.5565Z",
  fill: "#0C2846",
  stroke: "#0C2846",
  strokeWidth: 0.5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 13 15)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 13 27)",
  stroke: "#0081CC"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.7764 1.4799C19.7764 1.41468 19.7877 1.37393 19.8102 1.35762C19.8328 1.34132 19.8818 1.33317 19.957 1.33317H20.0248H20.1942C20.2092 1.34947 20.3146 1.45952 20.5103 1.66331C20.7061 1.8671 20.8754 2.04235 21.0185 2.18908C21.1615 2.33581 21.3647 2.58443 21.6282 2.93495C21.8917 3.28547 22.1251 3.6156 22.3283 3.92536C22.5316 4.23512 22.7687 4.64677 23.0397 5.16032C23.3107 5.67387 23.5441 6.17926 23.7398 6.67651C23.9355 7.17375 24.1425 7.78104 24.3608 8.49838C24.5791 9.21571 24.7485 9.93305 24.869 10.6504C24.9894 11.3677 25.0986 12.1951 25.1964 13.1325C25.2943 14.07 25.3395 15.0237 25.3319 15.9937C25.3319 16.9475 25.3056 17.7545 25.2529 18.4147C24.8991 23.0774 23.5553 26.7986 21.2217 29.5783C21.0486 29.7821 20.8867 29.9614 20.7362 30.1163C20.5856 30.2712 20.4614 30.4016 20.3635 30.5075C20.2657 30.6135 20.2092 30.6665 20.1942 30.6665H20.0248C19.9269 30.6665 19.8629 30.6584 19.8328 30.642C19.8027 30.6257 19.7839 30.585 19.7764 30.5198C20.1829 30.0796 20.5818 29.5742 20.9733 29.0036C23.1413 25.8815 24.2253 21.5449 24.2253 15.9937C24.2253 14.3471 24.1275 12.8105 23.9317 11.384C23.736 9.9575 23.4951 8.75923 23.2091 7.78919C22.923 6.81916 22.573 5.90619 22.1589 5.05027C21.7449 4.19436 21.3685 3.53001 21.0298 3.05722C20.691 2.58443 20.3184 2.11164 19.9119 1.63885C19.8968 1.62255 19.8818 1.60625 19.8667 1.58994C19.8516 1.57364 19.8404 1.55734 19.8328 1.54103C19.8253 1.52473 19.814 1.5125 19.799 1.50435L19.7764 1.4799Z",
  fill: "#0C2846",
  stroke: "#0C2846",
  strokeWidth: 0.5
});

const SvgEquationRadicalsFractions5 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationRadicalsFractions5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-radicals-fractions-5.165becab.svg";
export { ForwardRef as ReactComponent };